import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Fab from "@material-ui/core/Fab";

const styles = theme => ({
  fab: {
  },
  extendedIcon: {
    marginRight: theme.spacing.unit
  },
  container: {
    display: "inline-flex",
    height: "20%",
    marginLeft: '-20px',
    marginTop: '25px'
  }
});

const iconStyle = {
  fontSize: '1.5em'
};

const FloatingActionButtons = props => {
  const { classes, onDelete, onEdit, onTransfer, onDeSelect, dragHandleProps } = props;
  return (
    <div className={classes.container}>
      <Fab
        color="primary"
        aria-label="Edit"
        onClick={onEdit}
        className={classes.fab}
      >
        <i className="fa fa-cog" style={iconStyle} />
      </Fab>
      <Fab
        aria-label="Delete"
        color="secondary"
        onClick={onDelete}
        className={classes.fab}
      >
        <i className="fa fa-trash" style={iconStyle} onClick={onDelete} />
      </Fab>
      <Fab
        aria-label="Move"
        className={classes.fab}
      >
        <i  {...dragHandleProps} className="fa fa-move" style={iconStyle} onClick={onDelete} />
      </Fab>
    </div>
  );
};
export default withStyles(styles)(FloatingActionButtons);
